/**
 * @file 主账号业务用量页面
 */
<template>
  <div class="p-business-usage">
    <div class="p-business-usage-search">
      <plv-condition-filter v-model="conditionFilter" @search="handleSearch">
        <plv-condition-filter-item label="账期">
          <el-date-picker
            v-model="conditionFilter.dateRange"
            value-format="timestamp"
            size="small"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :picker-options="{
              disabledDate: filterDisabledMonth,
              onPick: onMonthPicker
            }"
            :clearable="false"
            :default-time="['00:00:00', '23:59:59']"
          />
        </plv-condition-filter-item>
        <plv-condition-filter-item
          prop="productItem"
          label="产品分类"
        >
          <plv-cascader
            v-model="conditionFilter.billItem"
            :options="productOptions"
            placeholder="请选择"
          />
        </plv-condition-filter-item>

        <plv-condition-filter-item
          prop="email"
          label="分账号邮箱"
          placeholder="请输入分账号邮箱"
          type="input"
        />
        <plv-condition-filter-item
          prop="status"
          label="状态"
          type="select"
          :select-options="paymentStatusOptions"
        />

        <plv-condition-filter-item type="search" />
      </plv-condition-filter>
    </div>
    <div class="p-business-usage-export">
      <plv-button @click="handleExportFile">导出数据</plv-button>
    </div>
    <div class="p-business-usage-table">
      <plv-table v-loading="loading" :data-source.sync="dataSource" @pageDataChange="handlePageChange">
        <plv-table-column
          v-for="item of tableItems"
          :key="item.prop"
          :title="item.title"
          :prop="item.prop"
        >
          <template v-if="item.prop === 'univalence'" slot="header">
            <span class="p-business-usage__header-with-tip">
              <span>{{ item.title }}</span>
              <plv-tooltip content="此单价为集团为该分账号配置的结算价格">
                <plv-icon class="p-business-usage__header-icon" icon="question-circle" />
              </plv-tooltip>
            </span>
          </template>
          <template slot-scope="scope">
            <span>{{ getTableValue(item.prop, scope.rowData) }}</span>
          </template>
        </plv-table-column>
      </plv-table>
    </div>
  </div>
</template>

<script>
import billMixin from '@/mixins/bill';
import { exportFile } from '@/utils/utils';
export default {
  mixins: [billMixin],
  data() {
    return {
      loading: false,
      tableItems: [
        { title: '账期', prop: 'accountPeriod' },
        { title: '分账号邮箱', prop: 'email' },
        { title: '备注', prop: 'memo' },
        { title: '产品', prop: 'production' },
        { title: '计费项', prop: 'category' },
        { title: '使用用量', prop: 'itemConsumed' },
        { title: '用量单位', prop: 'itemConsumedUnit' },
        { title: '结算日期', prop: 'statAt' },
        { title: '结算用量', prop: 'clearingItemConsumed' },
        { title: '单价', prop: 'univalence' },
        { title: '单价单位', prop: 'univalenceUnit' },
        { title: '使用日期', prop: 'consumeDate' },
        { title: '费用', prop: 'cost' },
        { title: '状态', prop: 'status' }
      ]
    };
  },

  created() {
    this.getBusinessUsage();
  },
  methods: {
    async getBusinessUsage() {
      const params = this.getSearchParams();
      try {
        this.loading = true;
        const res = await this.$store.dispatch('account/getAccountDosage', params);
        this.dataSource.contents = res.contents;
        this.dataSource.pageNumber = res.pageNumber;
        this.dataSource.pageSize = res.pageSize;
        this.dataSource.totalItems = res.totalItems;
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.dataSource.pageNumber = 1;
      this.getBusinessUsage();
    },
    handlePageChange() {
      this.getBusinessUsage();
    },
    async handleExportFile() {
      const params = this.getExportParams();
      const res = await this.$store.dispatch('account/exportDosageFile', params);
      res && exportFile(res);
    },
    getExportParams() {
      const params = this.getSearchParams();
      delete params.pageNumber;
      delete params.pageSize;
      return params;
    }
  }
};
</script>

<style lang="scss" scoped>
.p-business-usage {
  padding: 0 18px;
  .p-business-usage-export {
    margin-bottom: 20px;
  }
  .p-business-usage__header-with-tip {
    display: inline-flex;
    align-items: center;
  }
  .p-business-usage__header-icon {
    margin-left: 4px;
    color: #909399;
    cursor: pointer;
  }
}
</style>
